// extracted by mini-css-extract-plugin
module.exports =  {"shortDescriptionRoot":"ShortDescription-module__shortDescriptionRoot--R3AQ4","heading":"ShortDescription-module__heading--RsLQf","text":"ShortDescription-module__text--MbKRr"};